module.exports = __webpack_public_path__ + "img/2025-04-12b_1.317ec8bd.jpg";